import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/header_mobile.png'
import _imports_1 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-2af3e95e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mobile-container",
  ref: "pageRef"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, "Payment Approval"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "header-image",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "total" }
const _hoisted_4 = { class: "control-right" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Reject")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Approve")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "Approval Infomation")
], -1))
const _hoisted_8 = { class: "detail-list" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Payout Round:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Payout Code:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Program No.:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Vin No.:", -1))
const _hoisted_13 = { class: "detail-table" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Payout Amount w VAT:", -1))
const _hoisted_15 = { class: "program-label" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Approval Path")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeOutlined = _resolveComponent("HomeOutlined")!
  const _component_m_button = _resolveComponent("m-button")!
  const _component_m_segment = _resolveComponent("m-segment")!
  const _component_m_title = _resolveComponent("m-title")!
  const _component_ApproveSteps = _resolveComponent("ApproveSteps")!
  const _component_approval_modal = _resolveComponent("approval-modal")!
  const _component_m_info_modal = _resolveComponent("m-info-modal")!
  const _component_m_to_top = _resolveComponent("m-to-top")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      ref: "fixedRef",
      class: _normalizeClass([_ctx.isFixed ? 'is-fixed' : '', 'control', 'c-p'])
    }, [
      _createElementVNode("div", {
        class: "control-left",
        onTouchstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toHomePage && _ctx.toHomePage(...args)))
      }, [
        _createVNode(_component_HomeOutlined, { class: "home" }),
        _createElementVNode("span", _hoisted_3, _toDisplayString('(' + _ctx.total + ')'), 1)
      ], 32),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_m_button, {
          class: "mr-24",
          onTap: _ctx.handleReject
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onTap"]),
        _createVNode(_component_m_button, {
          type: "primary",
          onTap: _ctx.handleApprove
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onTap"])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.isFixed ? 'fixed-after-item' : '', 'content'])
    }, [
      _hoisted_7,
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", null, [
          _hoisted_9,
          _createElementVNode("span", null, _toDisplayString(_ctx.data.payoutRond), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_10,
          _createElementVNode("span", null, _toDisplayString(_ctx.data.payoutCode), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_ctx.toThousands(_ctx.data.programNo)), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_12,
          _createElementVNode("span", null, _toDisplayString(_ctx.toThousands(_ctx.data.vinNo)), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", null, _toDisplayString(_ctx.data.payoutAmountWVat || '0'), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programYear, ({payoutAmountWVat, programCode}) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: programCode }, [
                _createElementVNode("label", _hoisted_15, _toDisplayString('Program ' + programCode) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(payoutAmountWVat), 1)
              ], 64))
            }), 128))
          ])
        ])
      ])
    ], 2),
    _createVNode(_component_m_segment, { class: "mt-16 mb-16" }),
    _createVNode(_component_m_title, { class: "c-p mt-16 mb-16" }, {
      default: _withCtx(() => [
        _hoisted_16
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approveList, (item, index) => {
      return (_openBlock(), _createBlock(_component_ApproveSteps, {
        key: index,
        data: item
      }, null, 8, ["data"]))
    }), 128)),
    _createVNode(_component_approval_modal, {
      visible: _ctx.approvalModalVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.approvalModalVisible) = $event)),
      type: _ctx.actionType,
      formatkey: "payoutCode",
      list: [ _ctx.data ],
      onOnConfirm: _ctx.handleCommentsConfirm
    }, null, 8, ["visible", "type", "list", "onOnConfirm"]),
    _createVNode(_component_m_info_modal, {
      visible: _ctx.modalVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalVisible) = $event)),
      message: _ctx.modalMessage
    }, null, 8, ["visible", "message"]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_m_to_top, {
        "page-element": _ctx.pageRef,
        class: "color"
      }, null, 8, ["page-element"])
    ], 512), [
      [_vShow, _ctx.toTopShow]
    ])
  ], 512))
}